import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useLazyI18next from '@wix/da-i18next/pkg/useLazyI18next';
import { translationsImportFailed, translationsPreparedForImport } from '../redux/actions/initialization';
import { getIsReduxInitialized } from '../redux/selectors/initialization';
export default function useI18next() {
    const dispatch = useDispatch();
    const isReduxInitialized = useSelector(getIsReduxInitialized);
    const lazyI18nextImporter = useCallback((language, namespace, callback)=>{
        import(`../assets/locale/messages_${language}.json`).then((resources)=>{
            callback(null, resources);
        }).catch((error)=>{
            dispatch(translationsImportFailed());
            callback(error, null);
        });
    }, [
        dispatch
    ]);
    useLazyI18next('damz', lazyI18nextImporter);
    useEffect(()=>{
        if (isReduxInitialized) {
            dispatch(translationsPreparedForImport());
        }
    }, [
        dispatch,
        isReduxInitialized
    ]);
}

//# sourceMappingURL=useI18next.js.map